import React, { useState, useEffect } from 'react';
import Login from './Components/Login';
import SuperAdminDashboard from './Components/SuperAdminDashboard';
import AdminDashboard from './Components/AdminDashboard';
import UserDashboard from './Components/UserDashboard';

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const user = localStorage.getItem('currentUser');
    if (user) {
      setCurrentUser(JSON.parse(user));
    }
  }, []);

  const handleLogin = (user) => {
    setCurrentUser(user);
  };

  if (!currentUser) {
    return <Login onLogin={handleLogin} />;
  }

  // Route based on user role hierarchy
  const renderDashboard = () => {
    switch (currentUser.role) {
      case 'Super Admin':
        return <SuperAdminDashboard />;
      case 'Admin':
        return <AdminDashboard />;
      case 'Department User':
        return <UserDashboard />;
      default:
        return <Login onLogin={handleLogin} />;
    }
  };

  return (
    <div className="App">
      {renderDashboard()}
    </div>
  );
}

export default App;